import { gql } from 'graphql-request';

export const DeleteTaskDocument = gql`
  mutation deleteTask($input: DeleteTaskInput!) {
    deleteTask(input: $input) {
      ok
      error {
        code
        message
      }
    }
  }
`;
